import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

import { Auth } from "components";
import { register } from "redux/slices/auth.slice";
import { useAppDispatch, useAppSelector } from "hooks";
import { GOOGLE_END_POINT, LINKED_IN_END_POINT, MICROSOFT_END_POINT } from "services/CONSTANTS";

import SignupIndividualView from "./SignupIndividualView";

export const SignupIndividualContainer = () => {
  const dispatch = useAppDispatch();
  const { isLoading } = useAppSelector((state) => state.auth);
  const { refId } = useParams();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      fullname: "",
      refId: refId ?? "",
      terms: false
    },
    validationSchema: Yup.object().shape({
      fullname: Yup.string().required("Fullname is required"),
      email: Yup.string().email("Invalid email address").required("Email is required"),
      password: Yup.string()
        .required("Password is required")
        .matches(
          /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
          "Weak Password. Password must have at least: 1 upper case, 1 digit, 1 special character, Minimum eight in length"
        ),
      refId: Yup.string(),
      terms: Yup.boolean().isTrue("Terms and condition not accepted")
    }),

    onSubmit: (details) => {
      void dispatch(
        register({
          email: details.email,
          password: details.password,
          firstName: details.fullname.split(" ")[0],
          lastName: details.fullname.split(" ")[1],
          refId: details.refId ? details.refId : undefined
        })
      )
        .unwrap()
        .then((res) => {
          setTimeout(() => {
            toast.success(
              `Verification Link has been sent to this email "${res.email}", kindly follow the instruction in the mail to verify your account`
            );
          }, 5000);
        });
    }
  });

  const googleLogin = () => {
    window.open(`${GOOGLE_END_POINT}?refId=${refId as string}`, "_self");
  };
  const microsoftLogin = () => {
    window.open(`${MICROSOFT_END_POINT}?refId = ${refId as string}`, "_self");
  };
  const linkedLogin = () => {
    window.open(`${LINKED_IN_END_POINT}?refId=${refId as string}`, "_self");
  };
  return (
    <Auth>
      <SignupIndividualView
        formik={formik}
        loading={isLoading}
        googleLogin={googleLogin}
        microsoftLogin={microsoftLogin}
        linkedLogin={linkedLogin}
      />
    </Auth>
  );
};
